var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoWifi = function SvgIcoWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 17,
    fill: "none",
    viewBox: "0 0 23 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.656 15.125a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M21.62 3.867a16.5 16.5 0 0 0-20.927 0A1.125 1.125 0 1 0 2.12 5.606a14.25 14.25 0 0 1 18.07 0 1.126 1.126 0 0 0 1.429-1.74m-3.015 3.35a12 12 0 0 0-14.897 0A1.125 1.125 0 0 0 5.105 8.98a9.75 9.75 0 0 1 12.103 0 1.125 1.125 0 0 0 1.397-1.764m-3.036 3.342a7.505 7.505 0 0 0-8.826 0 1.125 1.125 0 0 0 1.326 1.82 5.25 5.25 0 0 1 6.174 0 1.126 1.126 0 0 0 1.326-1.82"
  })));
};
export default SvgIcoWifi;